interface Props {
  firstName: string
  lastName: string | null
  picture: string | null
}

/**
 * Owner avatar — 64px round. Renders the picture when present, otherwise a
 * blue placeholder with first-letter(s) initials. Shared between the QR
 * landing card and the profile-access card.
 */
export default function Avatar({ firstName, lastName, picture }: Props) {
  if (picture) {
    const fullName = lastName ? `${firstName} ${lastName}` : firstName
    return <img src={picture} alt={fullName} className="avatar-img" />
  }

  const initials = `${firstName[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase()
  return (
    <div className="avatar-placeholder">
      <span className="avatar-initials">{initials}</span>
    </div>
  )
}
